function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "rename",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,1 L0,4 C0,4.6 0.4,5 1,5 L19,5 C19.6,5 20,4.6 20,4 L20,1 C20,0.4 19.6,0 19,0 L1,0 C0.4,0 0,0.4 0,1 Z M14,4 L2,4 C1.4,4 1,3.6 1,3 L1,2 C1,1.4 1.4,1 2,1 L14,1 C14.6,1 15,1.4 15,2 L15,3 C15,3.6 14.6,4 14,4 Z M1,12 L19,12 C19.6,12 20,11.6 20,11 L20,8 C20,7.4 19.6,7 19,7 L1,7 C0.4,7 0,7.4 0,8 L0,11 C0,11.6 0.4,12 1,12 Z M2,8 L6,8 C6.6,8 7,8.4 7,9 L7,10 C7,10.6 6.6,11 6,11 L2,11 C1.4,11 1,10.6 1,10 L1,9 C1,8.4 1.4,8 2,8 Z M1,19 L19,19 C19.6,19 20,18.6 20,18 L20,15 C20,14.4 19.6,14 19,14 L1,14 C0.4,14 0,14.4 0,15 L0,18 C0,18.6 0.4,19 1,19 Z M2,15 L11,15 C11.6,15 12,15.4 12,16 L12,17 C12,17.6 11.6,18 11,18 L2,18 C1.4,18 1,17.6 1,17 L1,16 C1,15.4 1.4,15 2,15 Z",
  id: "customization-svg-icon"
})));

function SvgCustomization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Customization") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomization);
export default __webpack_public_path__ + "static/media/customization.1c2ddb11.svg";
export { ForwardRef as ReactComponent };